module.exports = __webpack_public_path__ + "static/img/tihuo1.2e9dcad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/tihuo1.jpg
// module id = 1jc4
// module chunks = 33